import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  color: white;
  width: 100%;
  gap: 3rem;
  background-color: var(--cloud-gray);
  align-items: center;
  justify-content: center;
  padding: 1.5rem 1rem;
  

  h1 {
    font-size: 2rem;
    font-weight: 500;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 80%;
  background-color: white;
  border-radius: 2px;
  border: 1px solid var(--light-gray);

  &:focus-within {
    border-color: var(--primary-blue);
  }

  

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Mic = styled.div<{ $recording: boolean; $processing: boolean }>`
  cursor: pointer;
  height: 1.5rem;
  width: 1.5rem;
  display: flex;
  filter: ${({ $recording }) =>
    $recording
      ? "invert(16%) sepia(96%) saturate(7496%) hue-rotate(358deg) brightness(95%) contrast(118%)"
      : "none"};
    opacity: ${({ $processing }) => ($processing ? 0.3 : 1)};


`;

export const Input = styled.input`
  flex: 1;
  border: none;
  outline: none;
  padding: 1rem;
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const SendButton = styled.button`
  background-color: var(--primary-blue);
  padding: 1rem;
  border-radius: 2px;
  margin-left: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  color: var(--white);
  min-width: 80px;
  transition: filter 0.2s, background-color 0.2s;

  &:hover {
    background-color: var(--dark-blue);
    filter: brightness(0.9);
  }

  &:active {
    transform: scale(0.95);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.8;
    filter: brightness(0.8);
  }

  .btnSpinner {
    width: 18px;
    height: 18px;
    border: 2px solid rgba(255, 255, 255, 0.35);
    border-top-color: rgba(255, 255, 255, 1);
    border-radius: 50%;
    animation: ${spin} 0.8s linear infinite;
  }

  img {
    filter: brightness(0) invert(1);
    width: 20px;
    height: 20px;
  }
`;